export default __webpack_public_path__ + "static/media/location-mockup.70baf241.png";